import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "index",
    component: () => import('@/views/index/index'),
  },
  {
    // 核心技术
    path: "/coreTechnology",
    name: "coreTechnology",
    component: () => import('@/views/coreTechnology/coreTechnology.vue'),
  },
  {
    // 空间管理
    path: "/spaceManage",
    name: "spaceManage",
    component: () => import('@/views/spaceManage/spaceManage.vue'),
  },
  {
    // 行业赋能
    path: "/industryEmpower",
    name: "industryEmpower",
    component: () => import('@/views/industryEmpower/industryEmpower.vue'),
  },
  {
    // 人才管理
    path: "/talentManage",
    name: "talentManage",
    component: () => import('@/views/talentManage/talentManage.vue'),
  },
  {
    // 关于我们
    path: "/aboutUs",
    name: "aboutUs",
    component: () => import("../views/aboutUs/aboutUs.vue"),
  },

  {
    // 人员实名制
    path: "/peopleSystem",
    name: "peopleSystem",
    component: () => import("../views/peopleSystem/peopleSystem.vue"),
  },
  {
    // 安全管理
    path: "/secure",
    name: "secure",
    component: () => import("../views/secure/secure.vue"),
  },
  {
    //绿色工程
    path: "/greenProject",
    name: "greenProject",
    component: () => import("../views/greenProject/greenProject.vue"),
  },
  {
    //绿色工程
    path: "/AI",
    name: "AI",
    component: () => import("../views/AI/AI.vue"),
  },
  {
    //进度可视化
    path: "/bim",
    name: "bim",
    component: () => import("../views/bim/bim.vue"),
  }
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: "history",
  routes,
});
// 解决重复点击导航路由报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}




export default router;